import { setAccountCreationStatus } from '@tkmp/rfq/redux/actionCreators';
import {
	PasswordSessionStorageKeyName,
	generateTemporaryPassword,
	getTokenForUser,
	signUpUser,
	upsertWeddingForUser,
} from '@tkmp/rfq/redux/utils';
import { Logger } from '@utils/logger/logger';
import { guestCountToRange } from '../guestCountToRange';

export const autoCreateAccount =
	({
		email,
		firstName,
		lastName,
		weddingDate,
		guestCount,
	}: {
		email: string;
		firstName: string;
		lastName: string;
		weddingDate: string;
		guestCount: number;
	}): Redux.ThunkResult<Promise<boolean>> =>
	async (
		dispatch,
		_getState,
		membershipService?: MembershipService.Service,
	) => {
		if (!membershipService) return false;
		const temporaryPassword = generateTemporaryPassword();
		try {
			const response = await signUpUser({
				signUpDetails: {
					action: 'lead-autocreate',
					application: 'marketplace',
					brand: 'theknot',
					email,
					first_name: firstName,
					last_name: lastName,
					password: temporaryPassword,
				},
				membershipService,
			});
			const memberUuid = response.body.members.id;
			const token = await getTokenForUser(membershipService);
			await upsertWeddingForUser({
				memberUuid,
				token,
				weddingDate,
				guestCount: guestCountToRange(guestCount),
			});
			dispatch(setAccountCreationStatus('success'));
			dispatch({
				type: 'middleware/SET_SESSION_STORAGE',
				payload: {
					key: PasswordSessionStorageKeyName,
					value: temporaryPassword,
				},
			});
			return true;
		} catch (error) {
			Logger.error({
				log_message: 'Auto account creation failed',
				errorToLog: error,
				newRelic: true,
			});
			dispatch(setAccountCreationStatus('errored'));
			return false;
		}
	};
